/*
 * Naturepride design system — JS globale
 * Header (mega menu, menu mobile), card prodotto (formati, aggiunta rapida),
 * carrello (bolla, drawer, spedizione gratuita), toast, copia testo.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NP = window.NP || {};

  /* ------------------------------------------------------------ utils */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function formatMoney(cents, format) {
    var fmt = format || window.NP_MONEY_FORMAT || '€{{amount_with_comma_separator}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, '.', ',');
      }
    });
  }

  function toast(message, isError) {
    var t = document.createElement('div');
    t.className = 'np-toast' + (isError ? ' is-error' : '');
    t.setAttribute('role', 'status');
    t.textContent = message;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3000);
  }

  /* ------------------------------------------------------------ carrello */

  function updateFreeship(totalCents) {
    $$('[data-np-freeship]').forEach(function (box) {
      var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;
      var extra = parseInt(box.getAttribute('data-extra') || '0', 10) || 0;
      if (!threshold) return;
      var base = totalCents + extra;
      var left = Math.max(0, threshold - base);
      var pct = Math.min(100, Math.round(((threshold - left) / threshold) * 100));
      var text = box.querySelector('[data-np-freeship-text]');
      var bar = box.querySelector('.np-freeship__bar i');
      box.setAttribute('data-cart', totalCents);
      if (text) {
        text.innerHTML = left > 0
          ? 'Add <b class="np-num">' + formatMoney(left) + '</b> more for <b>free delivery</b>'
          : '<b>Free delivery</b> unlocked on this order';
      }
      if (bar) bar.style.width = pct + '%';
    });
  }

  function refreshCart(openDrawer) {
    /* il cassetto carrello del tema è uno snippet dentro <cart-drawer>, la sezione "cart-drawer" lo ri-renderizza */
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');

    var sectionsReq = fetch(ROOT + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        if (drawer && data['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var current = document.getElementById('CartDrawer');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            var overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
          }
          var freshDrawer = doc.querySelector('cart-drawer');
          drawer.classList.toggle('is-empty', !!(freshDrawer && freshDrawer.classList.contains('is-empty')));
          if (openDrawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); });
        }
      })
      .catch(function () {});

    var cartReq = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateFreeship(cart.total_price);
        document.dispatchEvent(new CustomEvent('np:cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});

    if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'np' }); } catch (e) { /* noop */ }
    }
    return Promise.all([sectionsReq, cartReq]);
  }

  function addToCart(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'This product could not be added');
        return json;
      });
    }).then(function (json) {
      var drawer = document.querySelector('cart-drawer');
      refreshCart(!!drawer);
      if (!drawer) toast(window.NP_STRINGS && window.NP_STRINGS.added ? window.NP_STRINGS.added : 'Added to your basket');
      return json;
    });
  }

  /* ------------------------------------------------------------ card */

  function cardVariants(card) {
    if (card.__npVariants) return card.__npVariants;
    var node = card.querySelector('[data-np-variants]');
    try { card.__npVariants = node ? JSON.parse(node.textContent) : []; } catch (e) { card.__npVariants = []; }
    return card.__npVariants;
  }

  function selectCardVariant(card, id) {
    var v = cardVariants(card).filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    $$('[data-np-size]', card).forEach(function (b) {
      var on = b.getAttribute('data-np-size') === String(id);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var price = $('[data-np-price]', card);
    var compare = $('[data-np-compare]', card);
    var wrap = $('[data-np-price-wrap]', card);
    var unit = $('[data-np-unit]', card);
    var add = $('[data-np-add]', card);
    var img = $('[data-np-card-img]', card);
    if (price) price.textContent = v.price;
    if (compare) { compare.hidden = !v.compare; if (v.compare) compare.textContent = v.compare; }
    if (wrap) wrap.classList.toggle('is-sale', !!v.compare);
    if (unit) { unit.textContent = v.unit || ''; unit.hidden = !v.unit; }
    if (add) { add.setAttribute('data-np-add', v.id); add.disabled = !v.available; }
    if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-np-size]');
    if (size) {
      e.preventDefault();
      selectCardVariant(size.closest('[data-np-card]'), size.getAttribute('data-np-size'));
      return;
    }

    var add = e.target.closest('button[data-np-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add('is-busy');
      addToCart([{ id: parseInt(add.getAttribute('data-np-add'), 10), quantity: 1 }])
        .then(function () {
          add.classList.remove('is-busy');
          add.classList.add('is-done');
          setTimeout(function () { add.classList.remove('is-done'); add.disabled = false; }, 1600);
        })
        .catch(function (err) {
          add.classList.remove('is-busy');
          add.disabled = false;
          toast(err.message, true);
        });
      return;
    }

    var copy = e.target.closest('[data-np-copy]');
    if (copy) {
      var value = copy.getAttribute('data-np-copy');
      var done = function () { toast('Copied ' + value); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(value).then(done).catch(function () { toast(value); });
      else toast(value);
    }
  });

  /* ------------------------------------------------------------ header */

  function initHeader() {
    var header = $('[data-np-header]');
    if (!header) return;

    /* altezza reale dell'header per gli elementi sticky delle pagine */
    var sticky = header.closest('.np-header-section') || header;
    function measure() { document.documentElement.style.setProperty('--np-header-h', sticky.offsetHeight + 'px'); }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(sticky);

    /* mega menu */
    var triggers = $$('[data-np-mega-trigger]', header);
    var closeTimer;
    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }
    function open(t) {
      clearTimeout(closeTimer);
      closeAll(t);
      t.setAttribute('aria-expanded', 'true');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    }
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(t);
      });
      var item = t.closest('.np-nav__item');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (window.matchMedia('(hover: hover)').matches) {
        item.addEventListener('mouseenter', function () { open(t); });
        item.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 160); });
        if (panel) {
          panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
          panel.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 160); });
        }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('pointerdown', function (e) { if (!e.target.closest('[data-np-header]')) closeAll(); });

    /* menu mobile */
    var burger = $('[data-np-burger]', header);
    var mnav = document.getElementById('NpMobileNav');
    var scrim = document.getElementById('NpMobileScrim');
    function closeMobile() {
      if (!mnav) return;
      mnav.hidden = true;
      if (scrim) scrim.hidden = true;
      document.documentElement.style.overflow = '';
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    }
    if (burger && mnav) {
      burger.addEventListener('click', function () {
        mnav.hidden = false;
        if (scrim) scrim.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        burger.setAttribute('aria-expanded', 'true');
        var first = mnav.querySelector('button, a, summary');
        if (first) first.focus();
      });
      $$('[data-np-mnav-close]').forEach(function (b) { b.addEventListener('click', closeMobile); });
      if (scrim) scrim.addEventListener('click', closeMobile);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mnav.hidden) closeMobile(); });
    }

    /* scorciatoia "/" per la ricerca */
    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (e.key === '/' && tag !== 'INPUT' && tag !== 'TEXTAREA') {
        var ss = document.querySelector('smart-search');
        if (ss && typeof ss.open === 'function') { e.preventDefault(); ss.open(''); }
      }
    });
  }

  /* ------------------------------------------------------------ newsletter */

  function initNewsletter() {
    $$('[data-np-news]').forEach(function (form) {
      if (location.search.indexOf('customer_posted=true') !== -1) {
        var msg = form.querySelector('[data-np-news-msg]');
        if (msg) msg.hidden = false;
      }
    });
  }

  function init() {
    initHeader();
    initNewsletter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  NP.toast = toast;
  NP.addToCart = addToCart;
  NP.refreshCart = refreshCart;
  NP.formatMoney = formatMoney;
  NP.updateFreeship = updateFreeship;
  window.NP = NP;
})();
